export enum PhoneConfirmationMethod {
  SmsConfirmation = 'sms_confirmation',
  SmsInvite = 'sms_invite',
  SmsOtp = 'sms_otp',
  AdminOverride = 'admin_override',
}
